import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "body"
};
const _hoisted_2 = {
  key: 0,
  class: "title"
};
const _hoisted_3 = {
  key: 1,
  class: "title title2"
};
const _hoisted_4 = {
  key: 2,
  class: "title title2"
};
import { useAppStore } from '@/store/modules/app';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'cheatDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 1
    },
    machineNo: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const store = useAppStore();
    const router = useRouter();
    const dialogVisible = ref(props.visible);
    const logout = () => {
      window.sessionStorage.clear();
      props.type === 1 && window.globalMethods.closeApp();
      if (props.type === 2) {
        router.replace('/plan');
        dialogVisible.value = false;
      }
    };
    watch(() => props.visible, () => {
      dialogVisible.value = props.visible;
    });
    watch(() => dialogVisible.value, () => {
      emits('update:visible', dialogVisible.value);
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, _mergeProps({
        width: "400px",
        "custom-class": "custom-dialog",
        "model-value": dialogVisible.value,
        "append-to-body": true,
        "lock-scroll": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        center: "",
        "destroy-on-close": ""
      }, _ctx.$attrs), _createSlots({
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_svg_icon, {
          "icon-class": __props.type === 2 ? 'tishi_solid' : 'jinggao_solid',
          "class-name": __props.type === 2 ? 'icon2' : 'icon'
        }, null, 8, ["icon-class", "class-name"]), __props.type === 1 ? (_openBlock(), _createElementBlock("label", _hoisted_2, "你已被标记为作弊！")) : _createCommentVNode("", true), __props.type === 2 ? (_openBlock(), _createElementBlock("label", _hoisted_3, " 你已被换至" + _toDisplayString(__props.machineNo) + "号机 ", 1)) : _createCommentVNode("", true), __props.type === 3 ? (_openBlock(), _createElementBlock("label", _hoisted_4, " 网络异常，请稍后... ")) : _createCommentVNode("", true)])]),
        _: 2
      }, [__props.type !== 3 ? {
        name: "footer",
        fn: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          class: "custom-btn",
          onClick: logout
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode(" 退出 ")])),
          _: 1
        })]),
        key: "0"
      } : undefined]), 1040, ["model-value"]);
    };
  }
});